import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentMediaSource } from '../../_hocs/withCurrentMediaSource';
import { useCurrentGallection } from '../../_hocs/withCurrentGallection';
import { MediaSourceType } from '../../types';
import { hideNewFolderPopup, showNewFolderPopup } from '../../actions';
import { getCurrentUserHasCore } from '../../../publicSession/selectors';
import { isPremiumGallection } from '../../../utils/gallections';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import NewGallectionPopup from '../NewGallectionPopup';
import Flex from '@wix/da-ds/pkg/Flex';
import { getIsShowingNewGallectionPopup } from '../../selectors';
import { URLS } from '@wix/da-url';
import { useSelector } from 'react-redux';
import { useMMDispatchActions, useMMSelector } from '../../_hocs/withOwnReduxStore';
import { useGlobalPrivs } from '../../_hocs/withGlobalPrivs';
import { useGruser } from '../../_hocs/withGruser';
import { getIsGroup } from '../../../User/helpers';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import { GallectionResourceType } from '../../../types/gallection';
export const AddGallectionButton = /*#__PURE__*/ React.memo(({ isSecondary })=>{
    const { t } = useTranslation();
    const hasCore = useSelector(getCurrentUserHasCore);
    const { currentMediaSource } = useCurrentMediaSource();
    const { canCreateGalleryFolder } = useGlobalPrivs();
    const { gruser } = useGruser();
    const isGroup = getIsGroup(gruser);
    const { currentGallection, currentFolderId } = useCurrentGallection();
    const { isShowingNewGallectionPopup } = useMMSelector((state)=>({
            isShowingNewGallectionPopup: getIsShowingNewGallectionPopup(state)
        }));
    const actions = useMMDispatchActions({
        showNewFolderPopup,
        hideNewFolderPopup
    });
    const { buttonText, buttonBiData } = useMemo(()=>{
        let text;
        let biTypeId = undefined;
        switch(currentMediaSource){
            case MediaSourceType.STASH:
                text = t('mediapopup.newStash');
                biTypeId = GallectionResourceType.STASH;
                break;
            case MediaSourceType.GALLERY:
                if (isSecondary) {
                    text = t('mediapopup.newGallery.newSubGallery');
                } else {
                    text = t('mediapopup.newGallery');
                }
                biTypeId = GallectionResourceType.GALLERY;
                break;
            case MediaSourceType.PRIVATE_COLLECTION:
                text = t('mediapopup.newPrivateCollection');
                biTypeId = GallectionResourceType.PRIVATE_COLLECTION;
                break;
            case MediaSourceType.COLLECTION:
            default:
                if (isSecondary) {
                    text = t('mediapopup.newCollection.newSubCollection');
                } else {
                    text = t('mediapopup.newCollection');
                }
                biTypeId = GallectionResourceType.COLLECTION;
                break;
        }
        return {
            buttonText: text,
            buttonBiData: BiData({
                evid: 40,
                itemid: currentFolderId,
                typeid: biTypeId,
                sectionname: BiContextProvidedValue,
                widgetname: BiContextProvidedValue
            })
        };
    }, [
        currentMediaSource,
        isSecondary,
        t,
        currentFolderId
    ]);
    if (currentMediaSource === MediaSourceType.GALLERY && !canCreateGalleryFolder) {
        return null;
    }
    if (isPremiumGallection(currentGallection)) {
        // completely hidden
        return null;
    }
    const isForSubfolders = !!currentFolderId;
    const restrictedToCore = isForSubfolders && !hasCore && !isGroup;
    const DSButton = isSecondary ? TextButton : GhostButton;
    const button = /*#__PURE__*/ React.createElement(DSButton, {
        variant: "main",
        size: "large",
        onClick: actions.showNewFolderPopup,
        disabled: restrictedToCore,
        icon: AddIcon,
        biData: buttonBiData
    }, buttonText);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, restrictedToCore ? /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        style: {
            gap: 4
        }
    }, /*#__PURE__*/ React.createElement(CoreBadge, {
        size: "large"
    }), /*#__PURE__*/ React.createElement("a", {
        href: URLS.CORE_MEMBERSHIP,
        target: "_blank",
        rel: "noopener noreferrer"
    }, button)) : button, isShowingNewGallectionPopup && /*#__PURE__*/ React.createElement(NewGallectionPopup, {
        onCancel: actions.hideNewFolderPopup,
        onDone: actions.hideNewFolderPopup
    }));
});
AddGallectionButton.displayName = 'AddGallectionButton';
export default AddGallectionButton;

//# sourceMappingURL=AddGallectionButton.js.map